import Vue from 'vue'
import Vuex from 'vuex'

import {fetch} from './fetch/api'

Vue.use(Vuex)

const setBodyOverflow = function (state) {
  document.body.setAttribute('style', state ? 'overflow:hidden' : '')
}

const formatCascader = function (res) {
  let data = []
  for (let i in res) {
    data.push({
      'value': res[i].id,
      'label': res[i].name,
      'status': res[i].status,
      'pid': res[i].pid,
      'number': res[i].number,
      'children': formatCascader(res[i].children)
    })
  }
  return data
}

export default new Vuex.Store({
  state: {
    maskShow: false,
    sidebarState: false,
    logined: false,
    activeWinId: '',
    userInfo: {
      menus: []
    },
    activeState: '',
    alerts: [],
    isSuperUser: false,
    loadingState: false,
    badge: {
      expense: 0,
      entry: 0,
      reg: 0,
      message: 0,
      leave: 0,
      quit: 0,
      ask: 0
    },
    token: '',
    department: [],
    isEntry: null,
    role: ['领导', '主管', '项目经理', '财务', '人事', '员工', '行政', '出纳'],
    roles: [
      {label: '总经理', value: 1},
      {label: '副总', pid: 1, value: 2},
      {label: '负责人', pid: 1, value: 2},
      {label: '人事', pid: 1, value: 3},
      {label: '财务', pid: 1, value: 4},
      {label: '员工', pid: 1, value: 5}
    ],
    stateInfo: [
      {label: '待审核', value: 0},
      {label: '待入职', value: 1},
      {label: '在职', value: 2},
      {label: '离职', value: 3},
      {label: '禁用', value: 4}
    ],
    admin_info: {},
    connect: false,
    message: null
  },
  mutations: {
    SOCKET_CONNECT: (state) => {
      state.connect = true
    },
    SOCKET_USER_MESSAGE: (state, message) => {
      state.message = message
    },
    // 设置token
    SET_TOKEN (state, token) {
      localStorage.setItem('token', token)
      state.token = token
      let random = Math.random()
      fetch(`/auth/me?random=${random}`)
        .then(res => {
          state.userInfo = res
          state.logined = true
          state.sidebarState = false
          // 是否办理了入职手续
          state.isEntry = state.userInfo.status === 2
          if (state.userInfo.nodes[0] === 'all') state.isSuperUser = true
        }).catch(() => {
          state.logined = false
          // localStorage.removeItem('token')
        })
    },
    // 设置需要打开的window
    SET_ACTIVEWINDOW (state, id) {
      state.activeWinId = id
    },
    // 遮罩层是否显示
    SET_MASKSTATE (state, maskState) {
      state.maskShow = maskState
      setBodyOverflow(maskState)
    },
    // 用户信息设置
    SET_USERINFO (state, userInfo) {
      for (let key in userInfo) {
        state.userInfo[key] = userInfo[key]
      }
    },
    SET_SIDEBAR_STATE (state, sideState) {
      state.sidebarState = sideState
      setBodyOverflow(sideState)
    },
    SET_ALERTS (state, item) {
      state.alerts.unshift(JSON.stringify(item))
    },
    SET_BADGE (state, obj) {
      state.badge[obj.key] = obj.value
    },
    UPDATE_MESSAGE_BADGE (state) {
      fetch('console/message_count/0').then(res => {
        if (res.status === 'ok') {
          state.badge['message'] = res.count
        }
      })
    },
    DEL_ALERTS (state, item) {
      state.alerts.splice(state.alerts.indexOf(item), 1)
    },
    DEPARTMENT (state, refresh) {
      if (refresh || state.department.length === 0) {
        fetch('fetch/department').then(res => {
          state.department = formatCascader(res)
        })
      }
    },
    // 退出登录
    LOGOUT (state) {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')
      state.token = ''
      state.userInfo = ''
      state.sidebarState = false
      state.logined = false
    },
    LOGSTATE (state, val) {
      state.logined = val
      if (val) {
        state.sidebarState = false
        // 是否办理了入职手续
        state.isEntry = state.userInfo.status === 2
        if (state.userInfo.nodes[0] === 'all') state.isSuperUser = true
      }
    },
    LOADINGSTATE (state, val) {
      state.loadingState = val
    }
  },
  actions: {
    setSideState ({commit}, value) {
      commit('SET_SIDEBAR_STATE', value)
    },
    setToken ({commit}, token) {
      commit('SET_TOKEN', token)
    },
    setBadge ({commit}, obj) {
      commit('SET_BADGE', obj)
    },
    updateBadge ({commit}) {
      commit('UPDATE_MESSAGE_BADGE')
    },
    activeWindow ({commit}, value) {
      commit('SET_ACTIVEWINDOW', value)
    },
    setUserInfo ({ commit }, value) {
      commit('SET_USERINFO', value)
    },
    setAlerts ({ commit }, value) {
      commit('SET_ALERTS', value)
    },
    delAlerts ({ commit }, value) {
      commit('DEL_ALERTS', value)
    },
    setMaskShow ({ commit }, value) {
      commit('SET_MASKSTATE', value)
    },
    logout ({ commit }) {
      commit('LOGOUT')
    },
    setLoginState ({ commit }, value) {
      commit('LOGSTATE', value)
    },
    setLoadingState ({ commit }, value) {
      commit('LOADINGSTATE', value)
    },
    setDepartment ({ commit }, value) {
      commit('DEPARTMENT', value)
    },
    otherAction: () => {
      return true
    },
    socket_userMessage: (context, message) => {
      context.dispatch('newMessage', message)
      context.commit('NEW_MESSAGE_RECEIVED', message)
      if (message.is_important) {
        context.dispatch('alertImportantMessage', message)
      }
    }
  }
})
